import useAuth from 'hooks/use-auth'
import {
  useAlfiClients,
  useInfraClients,
  useK8sClients
} from 'hooks/use-clients'
import { useFeatureFlags } from 'hooks/use-feature-flags'
import { useGameDays } from 'hooks/use-gamedays'
import { useServices } from 'hooks/use-services'

export default function useLongRunningApiData(enabled = true): void {
  const { createGamedays: isCreateGameDaysEnabled } = useFeatureFlags()
  const { hasReliabilityManagement, isPaywallActive } = useAuth()
  const { companyIsAlfiEnabled: isAlfiEnabled } = useAuth()

  const allEnabled = enabled && !isPaywallActive

  useGameDays(allEnabled && isCreateGameDaysEnabled)
  useServices(allEnabled && hasReliabilityManagement)
  useInfraClients({ enabled: allEnabled })
  useK8sClients({ enabled: allEnabled })
  useAlfiClients({ enabled: allEnabled && isAlfiEnabled })
}
